import * as bootstrap from 'bootstrap'

const bootstrapInstance = window.bootstrap || bootstrap;
if (!window.bootstrap) {
  window.bootstrap = bootstrapInstance;
}

export default bootstrapInstance;
